<div class="fixed inset-0 bg-slate-900/65 backdrop-blur-sm flex justify-center items-center z-50 no-scrollbar">
  <div class="bg-white dark:bg-gray-900 shadow-2xl rounded-2xl p-8 max-w-sm w-full mx-4 flex flex-col items-center gap-6 border border-slate-100 dark:border-slate-800 transition-all duration-300">
    <div class="spinner-container">
      <div class="glow-ring"></div>
      <div class="glow-ring-inner"></div>
    </div>
    <div class="text-center w-full">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 mb-1">Please Wait</h3>
      <p class="text-sm text-slate-500 dark:text-slate-400 font-medium animate-pulse break-words leading-relaxed">
        {{ message }}
      </p>
    </div>
  </div>
</div>
